import { render, staticRenderFns } from "./special-competition.vue?vue&type=template&id=25c4f3d8&"
import script from "./special-competition.vue?vue&type=script&lang=ts&"
export * from "./special-competition.vue?vue&type=script&lang=ts&"
import style0 from "./special-competition.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports